export default "__VITE_ASSET__7d1356fa__"